import { createFeatureSelector } from '@ngrx/store';
import { SelectorFactory } from './common/selector.factory';
import { createInitialSharedState, sharedFeatureKey, SharedState } from './shared.state';

export const selectSharedState = createFeatureSelector<SharedState>(sharedFeatureKey);

const factory = new SelectorFactory(selectSharedState, createInitialSharedState()).create();

export const selectTableRefreshers = factory.tableRefresher;
